import React, {useState, useEffect} from 'react'
import { Modal, Field, Chip } from '@arnsbogroup/react-voicearchive'
import { FormattedDate, FormattedTime, useIntl } from 'react-intl'
import messages from './messages'
import useCurrentUser from 'hooks/useCurrentUser'

const BookingInfoModal = ({bookingId, onClose = () => {}, show = false, ...props}) => {

    if (!bookingId) {
        return null;
    }

    const { formatMessage } = useIntl()
    const currentUser = useCurrentUser()
    const [booking, setBooking] = useState({
        supplier : {
            userid: ''
        },
        coordinator : {
            name: ''
        },
        uid: '',
        dateStart: 0,
        dateEnd: 0,
        message: '',
        dealId: ''
    })

    useEffect(() => {
        if (!bookingId || !show) {
            return
        }

        fetch(`/rest/v2/booking/${bookingId}?includeRelations=1`, { credentials: 'same-origin' }) 
            .then((response) => response.json())
            .then(({data}) => {
                setBooking(data)
            } )
            .catch((error) => toastr.error(error))
    } ,[bookingId, show])

    const getStatusChip = () => {
        const statusChip = {
            accepted: {
                state: 'success',
                text: formatMessage(messages.bookingAccepted)
            },
            rejected: {
                state: 'error',
                text: formatMessage(messages.bookingRejected)
            },
            pending: {
                state: 'warning',
                text: formatMessage(messages.bookingPending)
            },
        }

        let status = null;
        if (+ booking.accepted) {
            status = statusChip.accepted
        } else if (+ booking.rejected) {
            status = statusChip.rejected
        } else {
            status = statusChip.pending
        }
    
        return (
            <>
                { status &&
                    <Chip size="sm" state={status.state}>
                        <span className="capitalize">
                            { status ? status.text : '' }
                        </span>
                    </Chip>
                }
            </>
        )
    }

    return (
        <div>
            <Modal
                show={show}
                onClose={() => onClose()}
                onOutsideClick={() => onClose()}
                title={formatMessage(messages.title, { name: booking.supplier.userid })} 
            >
                <div className='grid grid-cols-2 gap-4 mb-4'>
                    <Field label={formatMessage(messages.bookingNumber)}>
                        <p className='break-words'>
                            { booking.uid }
                        </p>
                    </Field>
                    <Field label={formatMessage(messages.requestedBy)}>
                        <p className='break-words'>
                            { booking.coordinator.name }
                        </p>
                    </Field>
                    <Field label={formatMessage(messages.startDate)}>
                        <p className='break-words'>
                            <FormattedDate value={new Date(booking.dateStart * 1000)} /> <FormattedTime value={new Date(booking.dateStart * 1000)} />
                        </p>
                    </Field>
                    <Field label={formatMessage(messages.endDate)}>
                        <p className='break-words'>
                            <FormattedDate value={new Date(booking.dateEnd * 1000)} /> <FormattedTime value={new Date(booking.dateEnd * 1000)} />
                        </p>
                    </Field>
                    { currentUser.roles.includes("coordinator") &&
                        <Field label={formatMessage(messages.dealId)}>
                            <p className='break-words'>
                                { booking.dealId }
                            </p>
                        </Field>
                    }
                    <Field label={formatMessage(messages.status)}>
                        <p>
                            { getStatusChip() }
                        </p>
                    </Field>
                </div>
                <Field label={formatMessage(messages.bookingMessage)}>
                    <p className='break-words'>
                        { booking.message }
                    </p>
                </Field>
            </Modal>
        </div>
    )
}

export default BookingInfoModal
